module.exports = __webpack_public_path__ + "img/countdown-area-impostor.ebe438d9.webp";